function fromApi(data) {
  return {
    completedSuapsCount: data?.completed_suaps_count ?? 0,
    totalSavings: data?.total_savings ?? 0,
  };
}

export { fromApi };
